import { ServerResponse } from '../serverResponse';
import { JobPositionDTO } from '../jobPositionDTO';


export class JobPositionSerializer {
    fromJson(json: any): JobPositionDTO {
        //debugger;
        const data = new JobPositionDTO();
        if(json==null){return}
        else{
        data.id = json.id;
        data.name = json.name;
        data.technology=json.technology;
        data.jobCategory=json.jobCategory;
        data.jobPriority=json.priority ? json.priority : 'N/A';
        data.jobStatus = json.jobStatus ? json.jobStatus : 'N/A';
        data.noOfVacancies = json.noOfVacancies;
        data.createdOn = json.createdOn;
        data.jobDescription = json.jobDescription;
        data.jobAssignedRecruiter =json.jobAssignedRecruiter;
        data.jdFileURL = json.jdFileURL;
        data.openJobCount = json.openJobCount;
        data.closedJobCount = json.closedJobCount;
        data.pendingJobCount = json.pendingJobCount;
        
        return data;}
    }

    toJson(data: JobPositionDTO): any {
        //debugger;
        return {
            id: data.id,
            technology: data.technology,
            jobStatus: data.jobStatus,
            jobCategory: data.jobCategory,
            noOfVacancies: data.noOfVacancies,
            description: data.description,
            priority: data.jobPriority,
            jobDescription: data.jobDescription,
            createdOn: data.createdOn,
            jdFileURL: data.jdFileURL,
            openJobCount: data.openJobCount,
            closedJobCount: data.closedJobCount,
            pendingJobCount: data.pendingJobCount,
            jobAssignedRecruiter :data.jobAssignedRecruiter
        };
    }
}